var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-blue-900 text-white flex justify-center"},[_c('nav',{staticClass:"py-12 container"},[_c('div',{staticClass:"w-full text-center"},[_c('div',{staticClass:"opacity-50"},[_vm._v(" CloudCast AS (928 234 126) © "+_vm._s(new Date().getFullYear())+" "),_c('br'),_vm._v(" Crafted in Oslo, Norway. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }